import { render, staticRenderFns } from "./contentTagCreate.vue?vue&type=template&id=06ab0352&"
import script from "./contentTagCreate.vue?vue&type=script&lang=js&"
export * from "./contentTagCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports